import { useRef } from 'react';

export function useAbortController() {
  const abortController = useRef<AbortController | null>(null);

  const abortRequest = () => {
    if (abortController.current) {
      abortController.current.abort();
    }
    abortController.current = null;
  };

  const getAbortSignal = () => {
    abortRequest();

    abortController.current = new AbortController();
    return abortController.current.signal;
  };

  return { getAbortSignal, abortRequest };
}
